import type { ReactNode } from 'react';

export const symbol_animated_images: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m537-470 127-85q14-9.11 14-25.06Q678-596 664-605l-127-85q-15-10-31-1.25T490-665v170q0 17.5 16 26.25t31-1.25ZM318-258q-24 0-42-18t-18-42v-502q0-24 18-42t42-18h502q24 0 42 18t18 42v502q0 24-18 42t-42 18H318Zm0-60h502v-502H318v502Zm251-251ZM206-140Zm7 59q-25 3-44.5-11.5T146-132L82-630q-3-25 12.5-45t40.5-23l32-3q14-2 23 7.14 9 9.15 9 22.86 0 12-7.58 19.92-7.59 7.92-18.42 10.08l-31 3 65 498 569-69q12-2 22 6t12 20.39q2 12.39-5.5 21.5T784-150L213-81Z"
		/>
	</svg>
);
